(function () {
  if (window.fmcpAvisCarouselInit) return;
  window.fmcpAvisCarouselInit = true;

  var ROOT_SELECTOR = '[data-fmcp-avis-carousel]';
  var TRACK_SELECTOR = '[data-fmcp-track]';
  var CARD_SELECTOR = '[data-fmcp-card]';

  function toBoolean(value) {
    return String(value) === 'true';
  }

  function getGap(track) {
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || '0');
    return Number.isNaN(gap) ? 0 : gap;
  }

  function getStep(track) {
    var firstCard = track.querySelector(CARD_SELECTOR);
    if (!firstCard) return track.clientWidth;
    return firstCard.getBoundingClientRect().width + getGap(track);
  }

  function isAtStart(track) {
    return track.scrollLeft <= 2;
  }

  function isAtEnd(track) {
    return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  }

  function scrollToStart(track) {
    track.scrollTo({ left: 0, behavior: 'smooth' });
  }

  function scrollToEnd(track) {
    track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
  }

  function scrollNext(track) {
    if (isAtEnd(track)) {
      scrollToStart(track);
      return;
    }

    track.scrollBy({ left: getStep(track), behavior: 'smooth' });
  }

  function scrollPrev(track) {
    if (isAtStart(track)) {
      scrollToEnd(track);
      return;
    }

    track.scrollBy({ left: -getStep(track), behavior: 'smooth' });
  }

  function canSlide(track) {
    return track.scrollWidth > track.clientWidth + 3;
  }

  function bindRoot(root) {
    if (!root || root.dataset.fmcpBound === 'true') return;

    var track = root.querySelector(TRACK_SELECTOR);
    if (!track) return;

    root.dataset.fmcpBound = 'true';

    var prevButton = root.querySelector('[data-fmcp-prev]');
    var nextButton = root.querySelector('[data-fmcp-next]');

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        scrollPrev(track);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        scrollNext(track);
      });
    }

    var autoplayEnabled = toBoolean(root.dataset.autoplay);
    var pauseOnHover = toBoolean(root.dataset.pauseOnHover);
    var speed = parseInt(root.dataset.autoplaySpeed, 10);
    if (Number.isNaN(speed) || speed < 1000) speed = 4000;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isPaused = false;
    var intervalId;

    function refreshArrowState() {
      if (!prevButton || !nextButton) return;
      var canMove = canSlide(track);
      prevButton.disabled = !canMove;
      nextButton.disabled = !canMove;
    }

    function startAutoplay() {
      if (!autoplayEnabled || prefersReducedMotion || !canSlide(track)) return;
      if (intervalId) window.clearInterval(intervalId);

      intervalId = window.setInterval(function () {
        if (document.hidden || isPaused) return;
        scrollNext(track);
      }, speed);
    }

    function stopAutoplay() {
      if (!intervalId) return;
      window.clearInterval(intervalId);
      intervalId = null;
    }

    if (pauseOnHover) {
      root.addEventListener('mouseenter', function () {
        isPaused = true;
      });

      root.addEventListener('mouseleave', function () {
        isPaused = false;
      });
    }

    track.addEventListener(
      'pointerdown',
      function () {
        isPaused = true;
      },
      { passive: true }
    );

    track.addEventListener(
      'pointerup',
      function () {
        isPaused = false;
      },
      { passive: true }
    );

    track.addEventListener('scroll', refreshArrowState, { passive: true });

    window.addEventListener('resize', function () {
      refreshArrowState();
      stopAutoplay();
      startAutoplay();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
        return;
      }
      startAutoplay();
    });

    refreshArrowState();
    startAutoplay();
  }

  function init(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target.closest(CARD_SELECTOR);
    if (!card) return;

    card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

    var track = card.closest(TRACK_SELECTOR);
    if (!track) return;

    var root = card.closest(ROOT_SELECTOR);
    if (root) {
      root.dataset.fmcpSelected = 'true';
    }
  });
})();
